/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Loading } from '@/components/Loading'
import { useLogout } from '@/pages/sign/hooks'

export function Logout() {
  const { t } = useTranslation()
  const logout = useLogout()

  useEffect(() => {
    logout('/signin')
  }, [])

  return <Loading tip={`${t('Exiting')}...`} />
}
